import { createFileRoute, Outlet } from "@tanstack/react-router";
import AppHeader from "src/components/app/AppHeader/AppHeader";
import SiteFooter from "src/components/app/SiteFooter/SiteFooter";
import { StatusPageLayout } from "src/components/app/StatusPage/StatusPageLayout";
import styles from "src/components/blog/Blog.module.scss";
import DocsLanguageProvider from "src/components/docs/DocsLanguageProvider";
import { BLOG_FEED_PATH } from "src/lib/BlogFeed";
import { getBlogLayoutData } from "src/server/functions/AuthState";

export const Route = createFileRoute("/blog")({
  // The SDK language posts' examples render with, kept until `router.invalidate()`; changes
  // afterwards live in DocsLanguageProvider.
  loader: () => getBlogLayoutData(),
  staleTime: Number.POSITIVE_INFINITY,
  head: () => ({
    links: [
      {
        rel: "alternate",
        type: "application/rss+xml",
        title: "CalmLens blog",
        href: BLOG_FEED_PATH,
      },
    ],
  }),
  component: BlogLayout,
});

function BlogLayout() {
  const { initialLanguage, initialUiLibrary } = Route.useLoaderData();
  return (
    <div className={styles.page}>
      <AppHeader />
      <main id="main-content" tabIndex={-1} className={styles.main}>
        <DocsLanguageProvider initialLanguage={initialLanguage} initialUiLibrary={initialUiLibrary}>
          <StatusPageLayout>
            <Outlet />
          </StatusPageLayout>
        </DocsLanguageProvider>
      </main>
      <SiteFooter />
    </div>
  );
}
